import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { BcpComponent } from './bcp/bcp.component';
import { InterbankComponent } from './interbank/interbank.component';
import { PagaloPeComponent } from './pagalo-pe/pagalo-pe.component';



export const routes: Routes = [
    { path: '', component: HomeComponent, title: 'Home' },  // Ruta para HomeComponent
    { path: 'bcp', component: BcpComponent, title: 'BCP'},  // Página BCP
    { path: 'interbank', component: InterbankComponent, title: 'Interbank'},  // Página Interbank
    { path: 'pagalo-pe', component: PagaloPeComponent, title: 'pagalo-pe' }
  ];
